import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import { AppSidebar } from "./AppSidebar";
import { useLayout, useSidebar } from "../hooks/contexts";

const AppLayout: React.FC = () => {
  const { mainContentRef } = useLayout();
  const { isExpanded } = useSidebar();

  return (
    <div className="bg-[#f5eff1] min-h-screen">
      <div className="sticky top-0 z-600">
        <AppHeader />
      </div>

      <div className="flex">
        <div
          className={`sticky top-15 h-[calc(100vh-60px)] ml-3 mr-1 bg-gray-50 text-gray-900 rounded-tl-2xl transition-all duration-300 ease-in-out ${
            isExpanded ? "w-60" : "w-20"
          }`}
        >
          <AppSidebar />
        </div>

        <div
          className="flex-1 min-w-0 bg-white rounded-tl-[10px] px-0 pb-0 overflow-hidden"
          ref={mainContentRef}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export { AppLayout };
